import { Injectable, computed, effect, inject, untracked } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { AppUser } from '../models/';
import { UserResolverService } from './services/user-resolver.service';

@Injectable({ providedIn: 'root' })
export class UserProfileService {
    private _cookieService = inject(CookieService);
    private _userResolverService = inject(UserResolverService);

    user?: AppUser;
    isLoggedIn = false;

    readonly storeNumberSignal = computed(() => this._userResolverService.userInfo()?.StoreId?.trim() || undefined);
    readonly locIDSignal = computed(() => {
        const locID = this._userResolverService.userInfo()?.LocID;
        return typeof locID === 'number' && Number.isInteger(locID) && locID > 0 ? locID : undefined;
    });
    readonly customerIdSignal = computed(() => this.storeNumberSignal()?.slice(0, 4));

    constructor() {
        effect(() => {
            const storeNumber = this.storeNumberSignal();
            const locID = this.locIDSignal();

            untracked(() => {
                if (storeNumber) {
                    this._cookieService.set('storeNumber', storeNumber);
                } else {
                    this._cookieService.delete('storeNumber');
                }

                if (locID != null) {
                    this._cookieService.set('locID', locID.toString());
                } else {
                    this._cookieService.delete('locID');
                }
            });
        });
    }

    get storeNumber(): string | undefined {
        return this.storeNumberSignal();
    }

    get locID(): number | undefined {
        return this.locIDSignal();
    }

    getLocID(): number | undefined {
        return this.locIDSignal();
    }

    public get customerId(): string | undefined {
        return this.customerIdSignal();
    }

    public hasPermission(..._roleConst: string[]): boolean {
        return true; //SES: Right now stores can do everything in the app
    }
}
